import { render, staticRenderFns } from "./LoginWelcomBanner.vue?vue&type=template&id=3d23b33e&scoped=true&"
import script from "./LoginWelcomBanner.vue?vue&type=script&lang=js&"
export * from "./LoginWelcomBanner.vue?vue&type=script&lang=js&"
import style0 from "./LoginWelcomBanner.vue?vue&type=style&index=0&id=3d23b33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d23b33e",
  null
  
)

/* custom blocks */
import block0 from "@/locales/esh.locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cpublic%5Cmodules%5Clogin%5Ccomponents%5Clogin%5CLoginWelcomBanner.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports